import React from 'react';

import { TypographyTable } from '../index';

const headingValuesRefreshed = [
	{
		previewText: 'Aa',
		tokenName: 'font.heading.xxlarge',
		fontSize: '32px',
		lineHeight: '36px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.xlarge',
		fontSize: '28px',
		lineHeight: '32px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.large',
		fontSize: '24px',
		lineHeight: '28px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.medium',
		fontSize: '20px',
		lineHeight: '24px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.small',
		fontSize: '16px',
		lineHeight: '20px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.xsmall',
		fontSize: '14px',
		lineHeight: '20px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.heading.xxsmall',
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 653,
	},
];

/**
 * __Typography heading table__
 */
export const TypographyHeadingTable = (): React.JSX.Element => {
	return (
		<TypographyTable values={headingValuesRefreshed} testId="typography-heading-table-modernized" />
	);
};
